import VeicularComunicadoVenda from "./modelos/veicularComunicadoVenda";
import VeicularReenviarComunicadoVenda from "./modelos/veicularReenviarComunicadoVenda";
import NegativacaoBase3Pf from "./modelos/negativacaoBase3Pf";
import CancelarNegativacaoBase3Pf from "./modelos/cancelarNegativacaoBase3Pf";
import NegativacaoBase3Pj from "./modelos/negativacaoBase3Pj";
import CancelarNegativacaoBase3Pj from "./modelos/cancelarNegativacaoBase3Pj";
import VeicularAtpve from "./modelos/veicularAtpve";

export const getComponents = () => {
  return {
    VeicularComunicadoVenda,
    VeicularReenviarComunicadoVenda,
    NegativacaoBase3Pf,
    CancelarNegativacaoBase3Pf,
    NegativacaoBase3Pj,
    CancelarNegativacaoBase3Pj,
    VeicularAtpve
  };
};